// Multi-tenant: los barberos invitados usan la app desde /t/{slug}.
// Este módulo detecta el slug y parchea fetch para enviar las cabeceras de tenant
// en TODAS las llamadas a /api, sin tocar el resto de componentes.

let slug = null;
let patched = false;

export function initTenant() {
  const m = window.location.pathname.match(/^\/t\/([a-z0-9-]+)/);
  if (m) slug = m[1];
  if (patched) return slug;
  patched = true;
  const orig = window.fetch;
  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input.url;
    if (slug && url && url.includes("/api/")) {
      const headers = new Headers(init.headers || {});
      headers.set("X-Tenant-Slug", slug);
      const tok = localStorage.getItem("bl_tenant_token");
      if (tok) headers.set("X-Tenant-Token", tok);
      init = { ...init, headers };
    }
    return orig(input, init);
  };
  return slug;
}

export const isTenant = () => !!slug;
export const tenantSlug = () => slug;
export const isTenantAdminPath = () =>
  !!window.location.pathname.match(/^\/t\/[a-z0-9-]+\/admin/);
export const setTenantToken = (t) => localStorage.setItem("bl_tenant_token", t);
export const clearTenantToken = () => localStorage.removeItem("bl_tenant_token");

// Auto-inicialización al importar el módulo (cualquier componente lee el slug al instante)
initTenant();
